/*
  Proyecto FÉNIX — v69.23
  Garantiza funcionamiento del ordenamiento en colecciones.
  Conserva view=grid/list y cualquier tag actual.
*/
(function(){
  'use strict';

  function onReady(fn){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function(){
    var sort = document.getElementById('SortBy');
    if (!sort) return;

    // Marca visual de que el control está listo.
    var shell = sort.closest('.form-horizontal');
    if (shell) shell.classList.add('nm-sort-ready');

    var initial = sort.getAttribute('data-nm-bound');
    if (initial === 'true') return;
    sort.setAttribute('data-nm-bound', 'true');

    var navigate = function(){
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        var view = url.searchParams.get('view');
        if (view) url.searchParams.set('view', view);
        window.location.assign(url.toString());
      } catch(err){
        var q = window.location.search.replace(/^\?/, '');
        var params = new URLSearchParams(q);
        params.set('sort_by', sort.value);
        window.location.search = '?' + params.toString();
      }
    };

    sort.addEventListener('change', navigate);
    sort.addEventListener('input', function(){
      // En algunos navegadores dispara mejor al soltar la selección.
    });
  });
})();
